import { Injectable, inject } from '@angular/core';
import { Observable, ReplaySubject, Subject, Subscription } from 'rxjs';
import { Artist, InvoiceStatus } from '../../models/db-models';
import { DbService } from './db.service';

@Injectable({
  providedIn: 'root'
})
export class ArtistService {
  private db = inject(DbService);

  private _selectedArtistId$: Subject<string> = new ReplaySubject(1);
  private _signedInArtist$: Subject<Artist> = new ReplaySubject(1);
  private _selectedPartnerId$: Subject<string> = new ReplaySubject(1);
  private _artistIdsLabelSeeRevenue$: Subject<string[]> = new ReplaySubject(1);
  private _artistIdsPaymentByLabel$: Subject<string[]> = new ReplaySubject(1);
  private artistSubscription: Subscription;

  get selectedArtistId$(): Observable<string> {
    return this._selectedArtistId$;
  }

  get signedInArtist$(): Observable<Artist> {
    return this._signedInArtist$;
  }

  get artistIdsLabelSeeRevenue$(): Observable<string[]> {
    return this._artistIdsLabelSeeRevenue$;
  }

  get artistIdsPaymentByLabel$(): Observable<string[]> {
    return this._artistIdsPaymentByLabel$;
  }

  get selectedPartnerId$(): Observable<string> {
    return this._selectedPartnerId$;
  }

  async fetchArtist(userId: string, isAdmin: boolean) {
    if (userId) {
      this.artistSubscription?.unsubscribe();
      this.artistSubscription = this.db.getArtist(userId).subscribe(async (artist) => {
        if (artist) {
          this._signedInArtist$.next(artist);
        } else {
          this._signedInArtist$.next(null);
        }
      });

      this.getArtistIdsForSignedInUser(userId);
      this.selectArtistId(userId);
    } else {
      this._signedInArtist$.next(null);
    }
  }

  async getArtistIdsForSignedInUser(signedInUserId: string): Promise<void> {
    const artistIdsLabelSeeRevenue = await this.db.findArtistIdsThatLabelCanSeeOnce(signedInUserId, 'labelSeeRevenue');
    this._artistIdsLabelSeeRevenue$.next(artistIdsLabelSeeRevenue);
    const artistIdsPaymentByLabel = await this.db.findArtistIdsThatLabelCanSeeOnce(signedInUserId, 'paymentByLabel');
    this._artistIdsPaymentByLabel$.next(artistIdsPaymentByLabel);
  }

  async selectArtistId(id: string) {
    this._selectedArtistId$.next(id);
  }

  async clearSelectedArtistId() {
    this._selectedArtistId$.next(null);
    this._signedInArtist$.next(null);
  }

  getArtistName(artist: Artist): string {
    let name = artist?.name;
    if (artist?.labelName) {
      name = `[${artist.labelName}] ${name}`;
    }
    return name;
  }

  getColorByStatus(invoiceStatus: string) {
    switch (invoiceStatus) {
      case InvoiceStatus.OPEN:
        return 'success';
      case InvoiceStatus.ADVANCE:
        return 'medium';
      case InvoiceStatus.REQUESTED:
      case InvoiceStatus.SCHEDULED:
        return 'pending';
      case InvoiceStatus.PAID:
        return 'danger';
    }
    return 'primary';
  }

  getTranslatedStatus(invoiceStatus: string, total: number = 0) {
    switch (invoiceStatus) {
      case InvoiceStatus.OPEN:
        return 'disponível';
      case InvoiceStatus.REQUESTED:
      case InvoiceStatus.SCHEDULED:
        return 'em andamento';
      case InvoiceStatus.PAID:
        return 'pago';
      case InvoiceStatus.ADVANCE:
        return total >= 0 ? 'adiantamento' : 'crédito';
    }
    return 'indisponível';
  }

  getTranslatedStatusAdmin(invoiceStatus: string) {
    switch (invoiceStatus) {
      case InvoiceStatus.OPEN:
        return 'Em aberto';
      case InvoiceStatus.REQUESTED:
        return 'Solicitado';
      case InvoiceStatus.SCHEDULED:
        return 'Agendado';
      case InvoiceStatus.PAID:
        return 'Pago';
      case InvoiceStatus.ADVANCE:
        return 'ADIANTAMENTO';
    }
    return 'indisponível';
  }

}
